import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationES from './es/translation-es.json';
import translationEN from './en/translation-en.json';
import translationCA from './ca/translation-ca.json';

i18next.use(initReactI18next).init({
    lng: localStorage.getItem("idioma-selecionado") || "br",
    debug: true,
    resources: {
        en: {
            translation: translationEN,
        },
        es: {
            translation: translationES,
        },
        ca: {
            translation: translationCA,
        },
    },
});